import React from 'react';
import { Box } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Search = function Search(_ref) {
  var className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height;
  return /*#__PURE__*/_jsxs(Box, {
    as: "svg",
    $styles: {
      width: width,
      height: height
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "10.2308",
      cy: "10.0879",
      r: "6.23077",
      stroke: "currentColor",
      strokeWidth: "2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15 15.0002L21 21.0002",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    })]
  });
};

export default Search;